import { loginPageStore } from "./stores";

const NO_REDIRECT_ROUTES = [
  'password-reset',
  'login', // and email-login
  'verify-account'
]

const canRedirectUrl = (returnUrl: string): boolean => {
  for (let i = 0; i < NO_REDIRECT_ROUTES.length; i++) {
    if (returnUrl.includes(NO_REDIRECT_ROUTES[i])) return false
  }
  return true
}

export const setReturnUrl = () => {
  let returnUrl = window.location.hash.replace(/^#/, "")
  if (canRedirectUrl(returnUrl)) loginPageStore.setReturnUrl(returnUrl)
}

export const appHistory = {
  push: (url: string) => {
    if (url === "/login") setReturnUrl();
    loginPageStore.resetLoginScreen();
    window.location.hash = url;
  }
};
